import { useIntl } from "react-intl";
import { useState } from "react";
import { DocumentOnePageSparkle24Regular } from "@fluentui/react-icons";
import { PopoverView } from "@/components/atoms/popover";
import { SquareToggleButton } from "@/components/atoms/squareToggleButton";
import { MessagingConversationSummaryPopover } from "@/components/organisms/messagingConversationSummary";
import { InteractionType } from "@/common/types";
import { useIsAicLockedForInteraction } from "@/hooks/aicLocking";
import { VoiceCallSummaryButtonProps } from "./types";

export const VoiceCallSummaryButton = ({
	interactionId,
	interactionStartDate,
	firstAgentAssignedAt,
	canGenerateSummary,
	enableCallSummary,
}: VoiceCallSummaryButtonProps) => {
	const intl = useIntl();
	const [popoverOpen, setPopoverOpen] = useState(false);
	const isAicLocked = useIsAicLockedForInteraction(firstAgentAssignedAt);

	if (!interactionId || !enableCallSummary || !canGenerateSummary || isAicLocked) {
		return null;
	}

	return (
		<PopoverView
			trigger={
				<SquareToggleButton
					icon={<DocumentOnePageSparkle24Regular />}
					tooltip={intl.formatMessage({ id: "Summary.Show" })}
					onClick={() => setPopoverOpen(!popoverOpen)}
					checked={popoverOpen}
				/>
			}
			content={
				<MessagingConversationSummaryPopover
					closePopover={() => setPopoverOpen(false)}
					isOpen={popoverOpen}
					interactionId={interactionId}
					interactionType={InteractionType.Call}
					interactionStartDate={interactionStartDate}
				/>
			}
			positioning={{ position: "below", align: "end", offset: { mainAxis: 8 } }}
			open={popoverOpen}
		/>
	);
};
